export default __webpack_public_path__ + "media/images/images/icons/card-2-375f9fb8f7c4a2212c68c291e39f3e81.png";